import request from 'configuration/request';
import { httpBuildQuery } from 'helpers/utils';

export const clientApi = {
  getClient: (clientId) => {
    return request({
      url: `/client/${clientId}/`,
      method: 'GET',
    });
  },

  getClientDIIADocuments: (clientId) => {
    return request({
      url: `/client/${clientId}/get_diia_documents/`,
      method: 'GET',
    });
  },

  sendDIIABarcode: (data) => {
    return request({
      url: '/client/diia/send_barcode/',
      method: 'POST',
      data,
    });
  },

  checkStatusDIIABarcode: (data) => {
    return request({
      url: '/client/diia/check_status_barcode/',
      method: 'POST',
      data,
    });
  },

  updateClient: (clientId, data) => {
    return request({
      url: `/client/${clientId}/`,
      method: 'PATCH',
      data,
    });
  },

  createClient: (data) => {
    return request({
      url: '/client/create/',
      method: 'POST',
      data,
    });
  },

  createContactPerson: (data) => {
    return request({
      url: '/contact_person/create/',
      method: 'POST',
      data,
    });
  },

  getClientList: (params) => {
    return request({
      url: `/client/list/${httpBuildQuery(params)}`,
      method: 'GET',
    });
  },

  getDocTypes: () => {
    return request({
      url: '/client/doc_type/list/',
      method: 'GET',
    });
  },

  getDocument: (id) => {
    return request({
      url: `/document/${id}/`,
      method: 'GET',
    });
  },

  createDocument: (data) => {
    return request({
      url: '/document/create/',
      method: 'POST',
      data,
    });
  },
};
